var _path, _path2, _path3, _path4, _ellipse, _ellipse2, _ellipse3, _ellipse4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconroad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 451,
    viewBox: "0 0 420 451",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M319.037 27.6568C319.039 20.3238 316.128 13.2904 310.944 8.10372C305.761 2.91707 298.729 0.00207726 291.396 1.10827e-06C287.765 -0.0010269 284.17 0.713116 280.815 2.10166C277.46 3.49019 274.411 5.52594 271.843 8.09265C266.656 13.2764 263.741 20.3082 263.739 27.6411C263.739 42.906 291.388 94.4463 291.388 94.4463C291.388 94.4463 319.037 42.9216 319.037 27.6568ZM278.174 27.6568C278.112 25.8843 278.408 24.1175 279.043 22.4616C279.678 20.8057 280.64 19.2946 281.872 18.0184C283.103 16.7422 284.579 15.727 286.211 15.0332C287.844 14.3395 289.599 13.9814 291.372 13.9804C293.146 13.9793 294.901 14.3353 296.534 15.0271C298.168 15.7189 299.645 16.7324 300.878 18.0072C302.111 19.2819 303.075 20.7918 303.712 22.447C304.349 24.1021 304.646 25.8686 304.586 27.6411C304.471 31.065 303.029 34.31 300.567 36.6918C298.105 39.0736 294.814 40.4061 291.388 40.4081C287.962 40.4101 284.669 39.0816 282.204 36.7027C279.739 34.3238 278.294 31.0805 278.174 27.6568Z",
    fill: "#181818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69 380.181L301 288.681L338.5 307.181L125 416.681L69 380.181Z",
    fill: "#181818"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M335.5 294.18L89.4999 193.18L96.5 176.18L348.5 269.681L335.5 294.18Z",
    fill: "#181818"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.981 163.206L270.943 122.621L273.738 133.959L109.516 180.639L106.981 163.206Z",
    fill: "#181818"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.5,
    cy: 407.181,
    rx: 88.5,
    ry: 43,
    fill: "#F29422"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 351.5,
    cy: 284.181,
    rx: 68.5,
    ry: 33,
    fill: "#270042"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.5,
    cy: 179.181,
    rx: 58.5,
    ry: 28,
    fill: "#270042"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 292,
    cy: 130.181,
    rx: 44,
    ry: 21,
    fill: "#270042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconroad);
export default __webpack_public_path__ + "static/media/iconroad.63aa4bac7e0ee538aacff6899094a6a6.svg";
export { ForwardRef as ReactComponent };